import { BillingClaimStatusType, SortDirection } from "@/Common/Models/UI/Enums";

class BillingClaimStatusReportSettings {
    public currentPageNumber: number;
    public searchText: string = "";
    public pageSize: number = 50;
    public claimStatusType: BillingClaimStatusType = BillingClaimStatusType.AppointmentDate;
    public sortDirection: SortDirection = SortDirection.DESC;

    constructor(currentPageNumber: number = 1) {
        this.currentPageNumber = currentPageNumber;
    }
}

export { BillingClaimStatusReportSettings };
